// Autogenerated file
export const mapObjectTypesEnum = {
    None: "None",
    BidPoint: "BidPoint",
    RouteSupportPoint: "RouteSupportPoint",
    GasStation: "GasStation",
    StartBidPoint: "StartBidPoint",
    PostamatPoint: "PostamatPoint",
    ItemChangePoint: "ItemChangePoint",
    ItemChangePointAddress: "ItemChangePointAddress",
    ServicePoint: "ServicePoint",
    CounterpartyPoint: "CounterpartyPoint",
    TripCouplingPoint: "TripCouplingPoint",
    PlatonPoint: "PlatonPoint",
    EmergencyAreaPoint: "EmergencyAreaPoint",
    RouteControlPoint: "RouteControlPoint",
};
export const mapObjectTypes = [
    { label: "Неизвестно", value: "None" },
    { label: "Точка загрузки/выгрузки", value: "BidPoint" },
    { label: "Промежуточная точка", value: "RouteSupportPoint" },
    { label: "Заправка", value: "GasStation" },
    { label: "Нулевая точка", value: "StartBidPoint" },
    { label: "Местоположение постамата", value: "PostamatPoint" },
    { label: "Точка перецепки/пересменки", value: "ItemChangePoint" },
    { label: "Адрес точки перецепки/пересменки", value: "ItemChangePointAddress" },
    { label: "Точка сервисных работ", value: "ServicePoint" },
    { label: "Адрес контрагента", value: "CounterpartyPoint" },
    { label: "Локация смены", value: "TripCouplingPoint" },
    { label: "Рамка Платон", value: "PlatonPoint" },
    { label: "Зона аварийного участка", value: "EmergencyAreaPoint" },
    { label: "Точка контроля маршрута", value: "RouteControlPoint" },
];
